import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import * as fromRoutes from "../actions/types";
import Sites from "./sites-container";
import Site from "./site-container";
import Summary from "./summary-container";
import { useRouter } from "utils";

const SITES_PATH = fromRoutes.SITES_PATH;

const SitesRoutes = ({ onGetSitesList, onSearchClear }) => {
	useEffect(() => {
		onSearchClear();
		onGetSitesList();
	}, [onGetSitesList, onSearchClear]);

	return (
		<Switch>
			<Route path={fromRoutes.SITE_TAB_ROUTE} component={Site} />
			<Route path={fromRoutes.SITES_ROUTE} exact component={Sites} />
		</Switch>
	);
};

SitesRoutes.propTypes = {
	onGetSitesList: PropTypes.func.isRequired,
	onSearchClear: PropTypes.func.isRequired,
};

/**
 * Site detail is a single page (summary + embedded sections). Legacy URLs such as
 * /sites/:id/notes or /sites/:id/records/... redirect to /sites/:id.
 */
export const ChildRoutes = () => {
	const { match, location } = useRouter();
	const siteId = match && match.params && match.params.siteId;
	const base = `${SITES_PATH}/${siteId}`;
	const pathname = (location && location.pathname) || "";
	const normalized = pathname.replace(/\/+$/, "");
	const normalizedBase = base.replace(/\/+$/, "");
	if (
		siteId &&
		normalized !== normalizedBase &&
		normalized.startsWith(`${normalizedBase}/`)
	) {
		return <Redirect to={base} />;
	}
	return <Summary />;
};

export default SitesRoutes;
